/* eslint-disable ember/no-computed-properties-in-native-classes */
import EmberObject, { computed, set } from '@ember/object';

import * as CircuitUtils from '../../utils/circuit';

export default class BasePieWedge extends EmberObject {
  center = null;
  range = null;
  explanatoryText = null;
  bigHugeCircuitGroup = null;
  circuit = null;
  /**
   * @description gets the interesting circuit among the array of big huge circuit.
   * @returns BigHugeCircuit
   */
  @computed('bigHugeCircuitGroup.circuits', 'center', 'circuit', 'range') get interestingCircuit() {
    var bigHugeCircuitArray = this.bigHugeCircuitGroup.circuits;
    var center = this.center;
    var range = this.range;

    var circuitsWithValidPhase = bigHugeCircuitArray.filter((circuit) => {
      var phase = circuit.phase;
      if (center - range / 2 < -180) {
        if (phase > 0) {
          phase = phase - 360;
        }
      }

      return center - range / 2 < phase && phase < center + range / 2;
    });

    var maxMagnitude = 0;
    var currentCircuit = null;
    var result = null;

    for (var i = 0; i < circuitsWithValidPhase.length; i++) {
      currentCircuit = circuitsWithValidPhase[i];
      var circuitMagnitude = currentCircuit.magnitude;
      if (circuitMagnitude > maxMagnitude) {
        maxMagnitude = circuitMagnitude;
        result = currentCircuit;
      }
    }

    let circuitCopy = null;
    if (result !== null) {
      circuitCopy = CircuitUtils.copyCircuit(this.circuit);
      var supportedComponents = circuitCopy.supportedComponents;

      for (let i = 0; i < supportedComponents.length; i++) {
        var property = supportedComponents[i];
        set(circuitCopy[property], 'value', result.get(property));
      }

      set(circuitCopy.opAmp, 'gbw', result.opAmpGbw);
    }

    return circuitCopy;
  }
}
